import * as a from "react";
const t = (e) => /* @__PURE__ */ a.createElement(
  "svg",
  {
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...e
  },
  /* @__PURE__ */ a.createElement(
    "path",
    {
      d: "M16.913 6.877H3.255a.458.458 0 00-.459.494L3.97 20.333A1.833 1.833 0 005.803 22h8.561a1.833 1.833 0 001.834-1.668l1.219-12.998a.457.457 0 00-.459-.495l-.045.037zM8.479 18.793a.687.687 0 01-1.374 0v-8.25a.687.687 0 011.374 0v8.25zm4.584 0a.687.687 0 11-1.375 0v-8.25a.687.687 0 111.375 0v8.25zM19.25 3.667h-4.355a.229.229 0 01-.229-.23V2.292A2.292 2.292 0 0012.374 0H7.791A2.292 2.292 0 005.5 2.292v1.145a.23.23 0 01-.23.23H.918a.917.917 0 000 1.833h18.332a.917.917 0 100-1.833zm-11.917-.23V2.292a.458.458 0 01.458-.459h4.583a.459.459 0 01.459.459v1.145a.229.229 0 01-.23.23h-5.04a.23.23 0 01-.23-.23z",
      fill: "#2d6ded"
    }
  )
), v = t;
export {
  v as default
};
